import { createContext } from "react";
import {
  DefaultAreas,
  DefaultPaymentTerms,
  DefaultZones,
  DefaultTaxRates,
} from "../utils/constants";
import { EMAIL_REGEX, URL_REGEX } from "../utils/useForm";

const validateYard = (values) => {
  debugger;
  let errors = {};
  if (!values.firstName || values.firstName.trim().length === 0)
    errors.firstName = "First name is required";
  if (!values.lastName || values.lastName.trim().length === 0)
    errors.lastName = "Last name is required";
  if (!values.userPhone || values.userPhone.trim().length === 0)
    errors.userPhone = "User phone is required";
  if (!values.businessName || values.businessName.trim().length === 0)
    errors.businessName = "Business name is required";
  if (!values.phoneNumber || values.phoneNumber.trim().length === 0)
    errors.phoneNumber = "Phone number is required";
  if (!values.email) errors.email = "Email is required";
  else if (!EMAIL_REGEX.test(values.email)) errors.email = "Invalid email";
  if (values.website && !URL_REGEX.test(values.website))
    errors.website = "Invalid URL";
  // try {
  //     values.website && new URL(values.website);
  // } catch (_) {
  //     errors.website = "Invalid URL";
  // }
  if (!values.street || values.street.trim().length === 0)
    errors.street = "Street name is required";
  if (!values.city || values.city.trim().length === 0)
    errors.city = "City is required";
  if (!values.state || values.state.trim().length === 0)
    errors.state = "State is required";
  if (!values.zip || values.zip.trim().length === 0)
    errors.zip = "Postal code is required";
  if (!values.country || values.country.trim().length === 0)
    errors.country = "Country is required";
  if (!values.timeZone || values.timeZone.trim().length === 0)
    errors.timeZone = "Time zone is required";

  return errors;
};

const validateAccess = (values) => {
  debugger;
  let errors = {};
  if (!values.lotCapacityAcres)
    errors.lotCapacityAcres = "Yard capacity is required";
  else if (isNaN(values.lotCapacityAcres) || values.lotCapacityAcres < 0)
    errors.lotCapacityAcres = "Invalid Yard capacity";
  if (!values.trackCapacity)
    errors.trackCapacity = "Track capacity is required";
  else if (values.trackCapacity && isNaN(values.trackCapacity))
    errors.trackCapacity = "Invalid track capacity";
  if (!values.warehouseCapacity)
    errors.warehouseCapacity = "Warehouse capacity is required";
  else if (isNaN(values.warehouseCapacity) || values.warehouseCapacity < 0)
    errors.warehouseCapacity = "Invalid Warehouse capacity";
  return errors;
};

const validateCommodities = (values) => {
  return {};
};

export const initState = {
  yardInfo: {
    firstName: "",
    lastName: "",
    userPhone: "",
    userEmail: "",
    businessName: "",
    phoneNumber: "",
    faxNumber: "",
    email: "",
    website: "",
    street: "",
    city: "",
    state: "",
    zip: "",
    country: "USA",
    taxRates: DefaultTaxRates,
    accessToRailHighway: [],
    lotCapacityAcres: "",
    trackCapacity: "",
    warehouseCapacity: "",
  },
  commodities: [],
  capabilities: [],
  forkLiftMaxCapacity: null,
  validators: [validateYard, validateAccess, validateCommodities],
  errors: {},
  note: "",
  activeStep: 0,
  areas: DefaultAreas,
  zones: DefaultZones,
  paymentTerms: DefaultPaymentTerms,
};

export default createContext(initState);
